// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"8ac00f18","735":"8ac00f18"}[chunkId] + ".chunk.css";
};